export default __webpack_public_path__ + "static/media/mixg_190929_0040.7565b9d6.jpg";